export default "__VITE_ASSET__Dle0k$Kv__"